import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { breadcrumbSchemaJson } from "../utils/breadcrumbSchema";
import Navbarsynergtech from "../Homepage/Navbarsynergtech/Navbarsynergtech";
import FooterAll from "../Homepage/FooterAll/FooterAll";
import Footer from "../Homepage/Footer/Footer";
// Same page banner (background image, heading and breadcrumb styles) as About, Team, Contact, etc.
import "../AboutusPage/AboutusNavbar/AboutusNavbar.css";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const styles = {
    container: {
      maxWidth: "900px",
      margin: "0 auto",
      padding: "44px 48px",
      background: "#ffffff",
      borderRadius: "15px",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
      fontFamily: "'Livvic', 'Open Sans', sans-serif",
      fontSize: "17px",
      lineHeight: 1.8,
      color: "#454545",
    },
    h1: {
      fontSize: "2rem",
      fontWeight: "700",
      color: "#111827",
      borderBottom: "2px solid #e5e7eb",
      paddingBottom: "10px",
      marginBottom: "25px",
    },
    section: {
      marginBottom: "30px",
    },
    h2: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: "1.3rem",
      fontWeight: "700",
      color: "#051d71",
      marginTop: "34px",
      marginBottom: "10px",
      paddingLeft: "14px",
      borderLeft: "4px solid #ff5e15",
    },
    p: {
      marginBottom: "16px",
    },
    ol: {
      paddingLeft: "20px",
      marginBottom: "16px",
    },
    ul: {
      paddingLeft: "20px",
      marginBottom: "16px",
    },
    li: {
      marginBottom: "8px",
    },
    strong: {
      color: "#051d71",
    },
  };

  return (
    <div>
      <Helmet>
        <title>Privacy & Cookies Policy | 360 SynergyTech</title>
        <meta
          name="description"
          content="Read 360 SynergyTech's Privacy & Cookies Policy to learn how we collect, use, store, and protect your personal information."
        />
        <link rel="canonical" href="https://360synergytech.com/privacy-policy" />

        <meta property="og:title" content="Privacy & Cookies Policy | 360 SynergyTech" />
        <meta name="twitter:title" content="Privacy & Cookies Policy | 360 SynergyTech" />
        <meta property="og:description" content="Read 360 SynergyTech's Privacy & Cookies Policy to learn how we collect, use, store, and protect your personal information." />
        <meta property="og:url" content="https://360synergytech.com/privacy-policy" />
        <script type="application/ld+json">{breadcrumbSchemaJson([{ name: "Privacy Policy", path: "/privacy-policy" }])}</script>
      </Helmet>
      <Navbarsynergtech />

      <div className="main_div_aboutusnavbar">
        <h1 className="Heading_navbar" style={{ marginTop: 0, marginBottom: "1rem" }}>
          PRIVACY POLICY
        </h1>
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Link to="/" className="para_aboutus_navbar_white text-decoration-none">
            Home
          </Link>
          <span className="para_aboutus_navbar_white">
            <MdOutlineKeyboardArrowRight />
          </span>
          <span className="para_aboutus_navbar_orange">Privacy Policy</span>
        </div>
      </div>

      <main className="privacy_page_main">
      <div style={styles.container}>
      <p style={styles.p}>
        At 360 SynergyTech (“we,” “our,” “us”), we value your trust and are committed to protecting your privacy. This Privacy & Cookies Policy outlines how we collect, use, store, and protect your personal information when you visit our website or access our services. By using our site, you consent to the practices outlined below.
      </p>

      <div style={styles.section}>
        <h2 style={styles.h2}>1. Information We Collect</h2>
        <p style={styles.p}>
          We may collect the following types of information:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <strong>Personal Information:</strong> Name, email address, phone number, company details, and any other data you provide via contact forms, sign-ups, or service requests.
          </li>
          <li style={styles.li}>
            <strong>Non-Personal Information:</strong> Browser type, device information, IP address, pages visited, and referring websites.
          </li>
          <li style={styles.li}>
            <strong>Cookies & Tracking Data:</strong> Small data files stored on your device to improve user experience and site performance.
          </li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>2. How We Use Your Information</h2>
        <p style={styles.p}>
          We use your information for purposes such as:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>Providing and improving our services.</li>
          <li style={styles.li}>Responding to inquiries and support requests.</li>
          <li style={styles.li}>Sending important updates, offers, and marketing communications (you may opt-out anytime).</li>
          <li style={styles.li}>Analyzing site usage to enhance functionality and user experience.</li>
          <li style={styles.li}>Meeting legal obligations and preventing fraudulent activities.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>3. Cookies Policy</h2>
        <p style={styles.p}>
          Cookies help us deliver a better browsing experience by remembering preferences, personalizing content, and analyzing traffic.
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <strong>Essential Cookies:</strong> Required for core website functions.
          </li>
          <li style={styles.li}>
            <strong>Performance Cookies:</strong> Help us understand how visitors interact with our site.
          </li>
          <li style={styles.li}>
            <strong>Functional Cookies:</strong> Remember user preferences for a smoother experience.
          </li>
          <li style={styles.li}>
            <strong>Advertising Cookies:</strong> Deliver relevant ads and measure campaign effectiveness.
          </li>
        </ul>
        <p style={styles.p}>
          You can manage or disable cookies through your browser settings. Be aware that disabling cookies could impact the functionality of the site.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>4. Sharing & Disclosure</h2>
        <p style={styles.p}>
          We never sell or lease your personal information. However, we may share it:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>With reliable service providers who help operate our website and deliver our services.</li>
          <li style={styles.li}>To comply with legal requirements or respond to lawful requests.</li>
          <li style={styles.li}>To protect our rights, safety, and property, or that of our users.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>5. Data Security</h2>
        <p style={styles.p}>
          We employ industry-standard security measures—such as SSL encryption, secure servers, and restricted access—to safeguard your data. Although we work hard to protect your information, no method of transmission over the internet is completely secure.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>6. Your Rights</h2>
        <p style={styles.p}>
          You have the right to:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>Access, correct, or delete your personal information.</li>
          <li style={styles.li}>Withdraw consent for marketing communications.</li>
          <li style={styles.li}>Request a copy of the personal information we hold about you.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>7. Third-Party Links</h2>
        <p style={styles.p}>
          Our site may contain links to third-party websites. We are not liable for the privacy practices or content of third-party websites.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>8. Updates to This Policy</h2>
        <p style={styles.p}>
          We may revise this Privacy & Cookies Policy periodically. Changes will be posted on this page with the “Last Updated” date.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>9. Contact Us</h2>
        <p style={styles.p}>
          If you have questions about this Privacy & Cookies Policy, please contact us at:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>📧 Email: info@360synergytech.com</li>
          
          <li style={styles.li}>📞 Phone: +92 324 9925737</li>
        </ul>
      </div>
      </div>
      </main>

      <FooterAll />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
